import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// Utils
import { useMediaQuery } from 'react-responsive';
import cn from '../../../utils/tools/cn';
import useScroll from '../../../utils/hooks/useScroll';

// Icons
import { ReactComponent as BurgerIcon } from '../../../assets/icons/burger.svg';

// Components
import Sidebar from '../Sidebar/Sidebar';
import BurgerMenu from '../../organisms/BurgerMenu/BurgerMenu';

import styles from './LayoutWithSidebar.module.scss';

function LayoutWithSidebar({ Component, withTabsBar }) {
  const isSmallLaptop = useMediaQuery({ maxWidth: 1220 });
  const { lockBodyScroll } = useScroll();

  const [burgerMenuIsOpened, setBurgerMenuIsOpened] = useState(false);

  useEffect(() => {
    lockBodyScroll(burgerMenuIsOpened);
  }, [burgerMenuIsOpened]);

  const desktopComponent = (
    <>
      <div className={styles.sidebar}>
        <Sidebar parentStyles={styles} />
      </div>

      <div className={cn([styles.content, 'd-flex a-stretch flex-auto'])}>
        <div className={cn([styles.max_wrapper, 'flex-auto', !withTabsBar ? 'p-40' : ''])}>
          <Component />
        </div>
      </div>
    </>
  );

  const smallLaptopComponent = (
    <div className="flex-auto max-w-100">
      <div className={styles.sticky}>
        <div className="d-flex j-end p-20 mobile-p-10">
          <button
            type="button"
            onClick={() => setBurgerMenuIsOpened(!burgerMenuIsOpened)}
            className={cn([styles.burger_opener, 'd-flex a-center j-center'])}
          >
            <BurgerIcon />
          </button>
        </div>

        <BurgerMenu isOpened={burgerMenuIsOpened} onClose={() => setBurgerMenuIsOpened(false)}>
          <Sidebar parentStyles={styles} />
        </BurgerMenu>
      </div>

      <div className="p-r-20 p-l-20 p-b-50">
        <Component />
      </div>
    </div>
  );

  return (
    <section className="p-relative d-flex a-stretch">
      {isSmallLaptop ? smallLaptopComponent : desktopComponent}

      <div id="dropdownActions_holder" />
    </section>
  );
}

LayoutWithSidebar.propTypes = {
  Component: PropTypes.func.isRequired,
  withTabsBar: PropTypes.bool,
};

LayoutWithSidebar.defaultProps = {
  withTabsBar: false,
};

export default LayoutWithSidebar;
